<template>
  <div>
    <Hero/>
    <Features/>
    <background-wrapper color="#FFEEE4">
      <div class="choose-your-template">
        <ContentWithImage sectionName="choose-your-template" text-size="sm" justify-center image-order="1" image-order-sm="0" h2/>
      </div>
    </background-wrapper>
    <background-wrapper :src="routeNameKebab + '/fullscreen-image_customize-your-theme-and-questions'" ext="png">
      <div class="customize-your-theme-and-questions">
        <ContentWithImage sectionName="customize-your-theme-and-questions" text-size="sm" justify-center image-order="0" image-order-sm="0" image-margin="auto 0 auto 130px" h2/>
      </div>
    </background-wrapper>
    <ContentWithImage class="select-your-recipients" sectionName="select-your-recipients" text-size="sm" justify-center image-order="1" image-order-sm="0" image-margin="auto 0 auto 130px" h2/>
    <RequestDemo/>
    <Tools/>
    <LetsGet/>
  </div>
</template>

<script>
import { Hero, Tools, LetsGet, Features, ContentWithImage, RequestDemo } from '@/components/ui/products'

export default {
  name: 'Surveys',
  components: { Hero, Tools, LetsGet, Features, ContentWithImage, RequestDemo },
  computed: {
    routeNameKebab: app => app.$toKebabCase(app.$route.name)
  }
}
</script>

<style lang="sass">
.select-your-recipients
  img
    width: 520px!important
    +media-breakpoint-down(sm)
      width: 460px!important
    +media-breakpoint-down(xs)
      width: 80%!important
</style>

<style lang="sass" scoped>
.choose-your-template
  display: flex
  flex-direction: column

.customize-your-theme-and-questions
  display: flex
  flex-direction: column
  padding-bottom: 270px
  +media-breakpoint-down(sm)
    padding-bottom: 400px
</style>



// WEBPACK FOOTER //
// src/components/products/Surveys/Surveys.vue